import { useState, useEffect, useContext } from "react"
import { AdminContext } from "~/contexts/AdminContext"
import ICamper from "~/interfaces/ICamper"
import { NewReservationContext } from "~/contexts/admin/NewReservationContext"
import { useDebouncedCallback } from "use-debounce"
import api from "~/api2"

const useExistingCamperWillBeOverridden = () => {
  const { camp } = useContext(AdminContext)
  const { inputFirstName, inputLastName, inputEmail, inputPhoneNumber, inputPhoneCountryCode } =
    useContext(NewReservationContext)
  const [existingCamperToBeOverridden, setExistingCamperToBeOverridden] = useState<ICamper | null>(null)

  const fetchCamper = useDebouncedCallback(() => {
    api.Camps.findCamperByData({
      campId: camp.id,
      email: inputEmail || undefined,
      phone_country_code: inputPhoneCountryCode || undefined,
      phone_number: inputPhoneNumber || undefined,
    })
      .then(({ campers }) => {
        const camper = campers?.[0]
        if (camper) {
          const camperFullPhone = `${camper.phone_country_code}${camper.phone_number}`
          const inputFullPhone = `${inputPhoneCountryCode || ""}${inputPhoneNumber || ""}`

          const firstNameChanged = camper.first_name !== inputFirstName && inputFirstName !== ""
          const lastNameChanged = camper.last_name !== inputLastName && inputLastName !== ""
          const emailChanged = camper.email !== inputEmail && inputEmail !== ""
          const phoneChanged = camperFullPhone !== inputFullPhone && inputFullPhone !== ""

          if (firstNameChanged || lastNameChanged || emailChanged || phoneChanged) {
            setExistingCamperToBeOverridden(camper)
          } else {
            setExistingCamperToBeOverridden(null)
          }
        } else {
          setExistingCamperToBeOverridden(null)
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }, 500)

  useEffect(() => {
    if (inputEmail || (inputPhoneNumber && inputPhoneCountryCode)) {
      fetchCamper()
    }
  }, [inputEmail, inputPhoneNumber, inputPhoneCountryCode, inputFirstName, inputLastName])

  return {
    existingCamperToBeOverridden,
  }
}

export default useExistingCamperWillBeOverridden
